import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MultiShipmentFormGroup } from '../../model';

@Component({
  selector: 'multi-shipment-components-tab',
  templateUrl: './components-tab.component.html',
  styleUrls: ['./components-tab.component.scss'],
  standalone: false,
})
export class ComponentsTabComponent {
  @Input({ required: true }) formGroup!: FormGroup<MultiShipmentFormGroup>;
}
